module.exports = __webpack_public_path__ + "img/barricas.4db575d1.jpg";